export default __webpack_public_path__ + "static/media/image_icon.9262c087.svg";